import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/api.model';
import { Rental, RentalList, RentalCreate, RentalReturn, RentalUpdate } from '../models/rental.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RentalService {
  private apiUrl = `${environment.apiUrl}/booking/rentals/`;

  constructor(private http: HttpClient) {}

  list(params?: HttpParams): Observable<PaginatedResponse<RentalList>> {
    return this.http.get<PaginatedResponse<RentalList>>(this.apiUrl, { params });
  }

  get(id: number): Observable<Rental> {
    return this.http.get<Rental>(`${this.apiUrl}${id}/`);
  }

  create(data: RentalCreate): Observable<Rental> {
    return this.http.post<Rental>(this.apiUrl, data);
  }

  returnCar(id: number, data: RentalReturn): Observable<Rental> {
    return this.http.post<Rental>(`${this.apiUrl}${id}/return-car/`, data);
  }

  update(id: number, data: RentalUpdate): Observable<Rental> {
    return this.http.patch<Rental>(`${this.apiUrl}${id}/`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}/`);
  }
}